import { render, staticRenderFns } from "./PageAnnouncementItem.vue?vue&type=template&id=7be0936c&scoped=true&"
import script from "./PageAnnouncementItem.vue?vue&type=script&lang=ts&"
export * from "./PageAnnouncementItem.vue?vue&type=script&lang=ts&"
import style0 from "./PageAnnouncementItem.vue?vue&type=style&index=0&id=7be0936c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be0936c",
  null
  
)

export default component.exports